<script>import { exception } from './index';
export let observable = false;
export let component;
export let code;
</script>

{#if observable}
	<!-- eslint-disable-next-line svelte/no-at-html-tags -->
	{@html exception(component, code)}
{/if}
